module.exports = __webpack_public_path__ + "static/img/downloadbg.a63f5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/downloadbg.png
// module id = mPz2
// module chunks = 1